module.exports = __webpack_public_path__ + "assets/img/2.bfc35913.png";